"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f1090 = void 0;
exports.f1090 = {
    "тілі": [
        3728,
        3731
    ],
    "тыла": [
        6664
    ],
    "тоҷикӣ": [
        7442
    ],
    "түркменче": [
        7535
    ],
    "татар": [
        7753
    ]
};
